"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var operators_1 = require("rxjs/operators");
var Observable_1 = require("rxjs/Observable");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var MultiplePartyNameResolverPipe = /** @class */ (function () {
    function MultiplePartyNameResolverPipe(kbService) {
        this.kbService = kbService;
    }
    MultiplePartyNameResolverPipe.prototype.transform = function (parties, partyDefinitions, currentLanguageId) {
        var partyNameMetaFields$ = this.kbService.getNameMetaFieldIds(partyDefinitions.category);
        var roleNameMetaFields$ = this.kbService.getNameMetaFieldIds(partyDefinitions.roleCategory);
        return Observable_1.Observable.zip(partyNameMetaFields$, roleNameMetaFields$)
            .pipe(operators_1.map(function (_a) {
            var partyNameMetaFields = _a[0], roleNameMetaFields = _a[1];
            return parties.map(function (party) {
                var partyName = partyNameMetaFields.map(function (metaField) {
                    var fieldValue = party.entity.getProperty(metaField.getSystemName()).value;
                    return fieldValue instanceof idm_crosscutting_concepts_frontend_1.MultilingualString ? fieldValue.getValue(currentLanguageId) : fieldValue;
                }).join(' ');
                if (party.role) {
                    var roleName = roleNameMetaFields.map(function (metaField) {
                        var fieldValue = party.role.getProperty(metaField.getSystemName()).value;
                        return fieldValue instanceof idm_crosscutting_concepts_frontend_1.MultilingualString ? fieldValue.getValue(currentLanguageId) : fieldValue;
                    }).join(' ');
                    return partyName + " / " + roleName;
                }
                return partyName;
            }).join(', ');
        }));
    };
    MultiplePartyNameResolverPipe = __decorate([
        core_1.Pipe({
            name: 'multiplePartyNameResolver',
            pure: true
        }),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService])
    ], MultiplePartyNameResolverPipe);
    return MultiplePartyNameResolverPipe;
}());
exports.MultiplePartyNameResolverPipe = MultiplePartyNameResolverPipe;
//# sourceMappingURL=multiple-party-name-resolver.pipe.js.map